(function() {
    'use strict';

    angular.module('allegro').controller('AllegroResponsibleProducerCreateController', AllegroResponsibleProducerCreateController);

    AllegroResponsibleProducerCreateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroResponsibleProducersDataSrvc',
        'allegroResponsibleProducerMessagesConst'
    ];

    function AllegroResponsibleProducerCreateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroResponsibleProducersDataSrvc,
        allegroResponsibleProducerMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            name: []
        };

        self.account = {};
        self.responsibleProducerData = {
            account: null,
            name: ''
        };

        self.getAccount = getAccount;
        self.createResponsibleProducer = createResponsibleProducer;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createResponsibleProducer() {
            self.loading = true;
            self.responsibleProducerData.account = self.account.pk;

            allegroResponsibleProducersDataSrvc.create(self.responsibleProducerData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroResponsibleProducerMessagesConst.add);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
